const messages = {
  en: {
    login: {
      welcomeMessage: "Welcome!",
      enterCredentials: "Enter your email and password to sign in",
      password: "Password",
      rememberMe: "Remember me",
      signIn: "Sign in",
      wrongPassword: "Wrong password!",
      unverified: "Email is not verified!",
      wrongCredentials: "Wrong Credentials!",
    },
    teachers: {
      teachers: "Teachers",
      teachersTable: "Teachers table",
      createTeacher: "Create new Teacher",
      createNewTeacher: "Creating of new Teacher",
      teacher: "Teacher",
      address: "Address",
      mobile: "Mobile",
      activ: "Acitve",
      employedSince: "Employed since",
      employedSinceDate: "Start date of work",
      details: "Details",
      teacherCreated: "Teacher Successfully Created!",
      teacherUpdated: "Teacher Successfully Updated!",
      teacherDeleted: "Teacher Successfully Deleted!",
      activated: "Teacher Successfully Activated!",
      search: "Search Teachers...",
      detail: {
        teacherDetails: "Teacher Detail",
        teacherName: "Teacher's Name",
        courseTitle: "Course Title",
        subcourseTitle: "Subcourse Title",
        numberOfCandidate: "Number of Candidates",
        subcourseStartDate: "Subcourse start date",
        currentSubcourseProgress: "Current Course progress",
        subcourseDuration: "Duration of the course",
        months: "months",
        month: "months",
        teachSubcourses: "This teacher teaches the following sub-courses: ",
      },
      edit: {
        editingTeacher: "Edit Teacher",
      },
      pastMonths: "Current payment",
      teacherPermanentlyDelete: "This action will permanatly delete Teacher!",
    },
    global: {
      appTitle: "Financial Assistant",
      selectLanguage: "Select Language",
      edit: "Edit",
      delete: "Delete",
      deleted: "Deleted",
      yes: "Yes",
      no: "No",
      close: "Close",
      createdAt: "Created date",
      logout: "Log out",
      currency: "GBP",
      create: "Create",
      error: "Error",
      requiredField: "Required fiels",
      areYouSure: "Are You Sure?",
      deletingCancelled: "Deleting Cancelled!",
      actionCancelled: "Action Cancelled!",
      typePass: "Enter your Password!",
      submit: "Submit",
      cancel: "Cancel",
      seasons: "Seasons",
      newSeason: "New Season",
      creatingCancelled: "Creating Cancelled!",
      loading: "Loading...",
      plsWait: "Please wait while we process your request...",
      roleUnauthenticated: "You are not authorized to perform this action!",
      activate: "Activate",
      uploadImage: "Upload Image",
      deleteForever: "Delete Forever",
      activationCancelled: "Activation Cancelled",
    },
    navigation: {
      search: "Search...",
    },
    courses: {
      createCourse: "Create new Course",
      createNewCourse: "Creating of new Course",
      selectCourse: "Select Course",
      courses: "Courses",
      coursesSubcourses: "Courses/Subcourses",
      title: "Course title",
      createdSuccessfully: "Course Successfully Created!",
      updatedSuccessfully: "Course Successfully Updated!",
      editingCourse: "Edit Course",
      successDelete: "Course Successfully Deleted!",
      activated: "Course Successfully Activated!",
      coursePermanentlyDelete:
        "This action will permanently delete the Course!",
      detail: {
        courseDetails: "Course Detail",
        selectCourse: "Select Course",
        courseName: "Course Title",
        subcourseTitle: "Subcourse Title",
        coursePrice: "Subcourse Price",
      },
    },
    subcourses: {
      subcourses: "Subcourses",
      createSubcourse: "Create new Subcourse",
      selectSubcourse: "Select Subcourse",
      createNewSubcourse: "Creating Subcourse",
      subcourseTitle: "Subcourse Title",
      subcourseDetails: "Subcourse Details",
      coursePrice: "Subcourse Price",
      numberOfMonths: "Subcourse Duration (Number of months)",
      startFrom: "Subcourse start date",
      discount: "Discount",
      addSubcourse: "Add Subcourse:",
      subcourseCreated: "Subcourse Successfully Created!",
      subcourseUpdated: "Subcourse Successfully Updated!",
      editingSubcourse: "Edit Subcourse",
      subcourseDeleted: "Subcourse successfully deleted!",
      checkKids: "The following candidates attend this subcourse: ",
      activated: "Subcourse successfully activated!",
      subcoursePermanentlyDelete:
        "This action will permanently delete the Subcourse!",
      successDelete: "Subcourse Successfully Deleted!",
      courseDeleted:
        "Activation is not possible. The Course this Subcourse belongs to has been deleted!",
    },
    parents: {
      parents: "Parents",
      parent: "Parent",
      name: "Parent's name",
      createParent: "Create new Parent",
      createNewParent: "Creating of new Parent",
      parentCreated: "Parent successfully created!",
      notes: "Notes",
      unpaidInstallments: "Unpaid Installments",
      sendigReminders: "Sending Reminders",
      kidsCount: "Number of Children",
      selectParent: "Select Parent",
      editingParent: "Edit Parent",
      parentEdited: "Parent successfully edited!",
      checkKids: "Parent is in charge of the following students:",
      parentPermanentlyDelete:
        "This action will permanently delete the Parent!",
      parentDeleted: "Parent successfully deleted!",
      search: "Search Parents...",
    },
    kids: {
      kids: "Candidates",
      kid: "Candidate",
      kid_s: "Candidates",
      name: "Candidate's Name",
      subscribedSubcourse: "Subscribed Subcourse",
      numberOfPayments: "Paid installments",
      sendigReminders: "Reminders sending",
      createKid: "Create Candidate",
      createNewKid: "Creating of Candidate",
      unpaidInstallments: "Record of paid/unpaid installments",
      birthday: "Date of birth",
      kidUpdating: "Candidate Updating",
      kidUpdated: "Candidate successfully updated!",
      kidDeleted: "Candidate successfully deleted!",
      numberByMonths: "Number of Candidates by Months",
      numberBySubcourses: "Number of Candidates by Subcourse",
      deletedKids: "Graduated Candidates",
      search: "Search Candidates...",
      kidStatistic: "Statistics of enrolled students by month",
      kidPermanentlyDelete:
        "This action will permanently delete the Candidate!",
      parentDeleted: "Activation is not possible. The parent has been deleted!",
      activated: "Candidate successfully activated!",
    },
    payments: {
      amount: "Payment amount",
      paymentDate: "Payment Date",
      sendReminders: "Send Reminders",
      remindersSent: "Reminders successfully sent!",
      sendRemindersWarning: "This Action will send Reminders to Parents!",
      currUnpiadAm: "Current Unpaid Amount ",
      partiallyPayment: "Percentage paid",
      shortViewPayment: "Short view of candidate debt/payment",
      unpaidInstallments: "Installments owed",
      fullDebt: "Total expected gross income",
      notAllowedReverse: "Records of payments made cannot be reversed!",
    },
    seasons: {
      createSeason: "Create New Season",
      seasonCreated: "Season Successfully Created!",
      seasonAlreadyCreated: "Season Already Created!",
      dbAlreadyExists: "Database Already Exists!",
      titles: "Seasons",
      title: "Season",
    },
    Dashboard: "Dashboard",
    Teachers: "Teachers",
    Pages: "Pages",
    Courses: "Courses",
    Subcourses: "Subcourses",
    Parents: "Parents",
    Kids: "Candidates",
    Kid: "Student",
    Deleted: "Deleted",
    Billing: "Billing",
    Profile: "Profile",
    SignIn: "Sign In",
    SignOut: "Sign Out",
    Payments: "Payments",
    Debits: "Debits",
    LoginForm: "Log In",
    Login: "Login",
    Logout: "Logout",
    Seasons: "Seasons",
  },
  sr: {
    login: {
      welcomeMessage: "Dobrodošli!",
      enterCredentials: "Unesite email i lozinku kako biste se prijavili",
      password: "Lozinka",
      rememberMe: "Zapamti me",
      signIn: "Prijava",
      wrongPassword: "Pogrešna lozinka!",
      unverified: "Email nije verifikovan!",
      wrongCredentials: "Netačni podaci za prijavu!",
    },
    teachers: {
      teachers: "Nastavnici",
      teachersTable: "Tabela nastavnika",
      createTeacher: "Kreiraj novog nastavnika",
      createNewTeacher: "Kreiranje novog nastavnika",
      teacher: "Nastavnik",
      address: "Adresa",
      mobile: "Mobilni tel.",
      activ: "Aktivan",
      employedSince: "Zaposlen od",
      employedSinceDate: "Datum početka rada",
      details: "Pregled",
      teacherCreated: "Nastavnik uspešno kreiran!",
      teacherUpdated: "Nastavnik uspešno ažuriran!",
      teacherDeleted: "Nastavnik uspešno obrisan!",
      activated: "Nastavnik uspešno aktiviran!",
      search: "Pretraži nastavnike...",
      detail: {
        teacherDetails: "Pregled nastavnika",
        teacherName: "Ime nastavnika",
        courseTitle: "Naziv kursa",
        subcourseTitle: "Naziv podkursa",
        numberOfCandidate: "Broj polaznika",
        subcourseStartDate: "Podkurs počeo:",
        currentSubcourseProgress: "Trenutni napredak podkursa",
        subcourseDuration: "Trajanje podkursa",
        months: "meseci",
        month: "meseca",
        teachSubcourses: "Ovaj nastavnik podučava sledeće podkurseve: ",
      },
      edit: {
        editingTeacher: "Ažuriranje nastavnika",
      },
      pastMonths: "Aktuelna rata",
      teacherPermanentlyDelete: "Ova akcija će trajno izbrisati nastavnika!",
    },
    global: {
      appTitle: "Finansijski Asistent",
      selectLanguage: "Izaberi jezik",
      edit: "Uredi",
      delete: "Obriši",
      deleted: "Obrisano",
      yes: "Da",
      no: "Ne",
      close: "Zatvori",
      createdAt: "Datum kreiranja",
      logout: "Odjava",
      currency: "RSD",
      create: "Kreiraj",
      error: "Greška",
      requiredField: "Obavezno polje",
      areYouSure: "Da li ste sigurni?",
      deletingCancelled: "Brisanje otkazano!",
      actionCancelled: "Radnja otkazana!",
      typePass: "Unesi lozinku!",
      submit: "Pošalji",
      cancel: "Odustani",
      seasons: "Sezone",
      newSeason: "Nova Sezona",
      creatingCancelled: "Kreiranje otkazano!",
      loading: "Obrada...",
      plsWait: "Molimo sačekajte dok se vaš zahtev obradi...",
      roleUnauthenticated: "Korisnik nije autorizovan za ovu radnju!",
      activate: "Aktiviraj",
      uploadImage: "Otprema slike",
      deleteForever: "Izbriši zauvek",
      activationCancelled: "Aktiviranje otkazano!",
    },
    navigation: {
      search: "Pretraži...",
    },
    courses: {
      createCourse: "Kreiraj kurs",
      createNewCourse: "Kreiranje kursa",
      selectCourse: "Izaberi kurs",
      courses: "Kursevi",
      coursesSubcourses: "Kursevi/Podkursevi",
      title: "Naziv kursa",
      createdSuccessfully: "Kurs uspešno kreiran!",
      updatedSuccessfully: "Kurs uspešno ažuriran!",
      editingCourse: "Ažuriranje kursa",
      successDelete: "Kurs uspešno obrisan!",
      activated: "Kurs uspešno aktiviran!",
      coursePermanentlyDelete: "Ova akcija će trajno izbrisati kurs!",
      detail: {
        courseDetails: "Pregled kursa",
        courseName: "Naziv kursa",
        subcourseTitle: "Naziv podkursa",
        coursePrice: "Cena podkursa",
      },
    },
    subcourses: {
      subcourses: "Podkursevi",
      createSubcourse: "Kreiraj podkurs",
      createNewSubcourse: "Kreiranje podkursa",
      selectSubcourse: "Izaberi podkurs",
      subcourseTitle: "Naziv podkursa",
      subcourseDetails: "Pregled podkursa",
      coursePrice: "Cena podkursa",
      numberOfMonths: "Trajanje podkursa (broj meseci)",
      startFrom: "Datum početka podkursa",
      discount: "Popust",
      addSubcourse: "Dodaj podkurs:",
      subcourseCreated: "Podkurs uspešno kreiran!",
      subcourseUpdated: "Podkurs uspešno ažuriran!",
      editingSubcourse: "Ažuriranje podkursa",
      subcourseDeleted: "Birsanje podkursa izvršeno!",
      checkKids: "Ovaj podkurs pohađaju sledeći polaznici: ",
      activated: "Podkurs uspešno aktiviran!",
      subcoursePermanentlyDelete: "Ova akcija će trajno obrisati podkurs!",
      successDelete: "Podkurs uspešno obrisan!",
      courseDeleted:
        "Aktivacija nije moguća. Kurs kome pripada ovaj podkurs je obrisan",
    },
    parents: {
      parents: "Roditelji",
      parent: "Roditelj",
      name: "Ime Roditelja",
      createParent: "Kreiraj roditelja",
      createNewParent: "Kreiranje roditelja",
      parentCreated: "Roditelj uspešno kreiran!",
      notes: "Beleške",
      unpaidInstallments: "Broj neplaćenih rata",
      sendigReminders: "Slanje podsetnika",
      kidsCount: "Broj dece",
      selectParent: "Izaberi roditelja",
      editingParent: "Ažuriranje roditelja",
      parentEdited: "Roditelj ažuriran!",
      checkKids: "Roditelj je nadležan za sledeće polaznike:",
      parentPermanentlyDelete: "Ova akcija će trajno obrisati roditelja!",
      parentDeleted: "Roditelj uspešno obrisan!",
      search: "Pretraži roditelje...",
    },
    kids: {
      kids: "Polaznici",
      kid: "Polaznik",
      kid_s: "Polaznika",
      name: "Ime polaznika",
      subscribedSubcourse: "Pohađa kurs",
      numberOfPayments: "Plaćeno rata",
      createKid: "Kreiraj polaznika",
      createNewKid: "Kreiranje polaznika",
      unpaidInstallments: "Evidencija plaćenih/neplaćenih rata",
      kidsCount: "Broj polaznika",
      birthday: "Datum rođenja",
      kidUpdating: "Ažuriranje polaznika",
      kidUpdated: "Polaznik ažuriran!",
      kidDeleted: "Polaznik uspešno obrisan!",
      numberByMonths: "Broj polaznika po mesecima",
      numberBySubcourses: "Broj polaznika po podkursu",
      deletedKids: "Svršeni polaznici",
      search: "Pretraži polaznike...",
      kidStatistic: "Statistika upisanih polaznika po mesecima",
      kidPermanentlyDelete: "Ova akcija će trajno obrisati polaznika!",
      parentDeleted: "Aktivacija nije moguća. Roditelj je obrisan!",
      activated: "Polaznik uspešno aktiviran!",
    },
    payments: {
      amount: "Iznos uplate",
      paymentDate: "Datum uplate",
      sendReminders: "Pošalji podsetnike",
      remindersSent: "Podsetnici uspešno poslati!",
      sendRemindersWarning: "Ova radnja će poslati potsetnike roditeljima!",
      currUnpiadAm: "Trenutni nenaplaćeni iznos ",
      partiallyPayment: "Procenat uplate",
      shortViewPayment: "Skraćeni prikaz duga/uplata polaznika",
      unpaidInstallments: "Duguje rata",
      fullDebt: "Ukupan očekivani bruto prihod",
      notAllowedReverse: "Evidencije izvršenih uplata se ne mogu stornirati!",
    },
    seasons: {
      createSeason: "Kreiraj novu sezonu",
      seasonCreated: "Sezona uspešno kreirana!",
      seasonAlreadyCreated: "Sezona je već kreirana!",
      dbAlreadyExists: "Baza podataka već postoji!",
      titles: "Sezone",
      title: "Sezona",
    },
    Dashboard: "Naslovna",
    Teachers: "Nastavnici",
    Pages: "Stranice",
    Courses: "Kursevi",
    Subcourses: "Podkursevi",
    Parents: "Roditelji",
    Kids: "Polaznici",
    Kid: "Polaznik",
    Deleted: "Obrisane stavke",
    Billing: "Plaćanja",
    Profile: "Profil",
    SignIn: "Prijavi se",
    SignOut: "Odjavi se",
    Payments: "Uplate",
    Debits: "Dugovanja",
    LoginForm: "Prijava",
    Login: "Prijava",
    Logout: "Odjava",
    Seasons: "Sezone",
  },
};
export default messages;
